<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19Ad1X2/9780316187466_cover_epub.jpg?1731806684245" alt="This image is the cover for the book Scouting Jasmine, Jaz Parks Adventures"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scouting Jasmine, Jaz Parks Adventures
      </h1>
      <p class="bookDescription body article font2">
        <p>Jaz Parks is on the hunt for a politically-powerful vampire; but little does she know that she herself is being hunted -- by her future boss, Vayl. In this exciting short story that takes place prior to <i>Once Bitten, Twice Shy</i>, Vayl sees Jaz in action for the very first time.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Rardin
      </h2>
      
      <p class="authorDescription body article"><B>Jennifer Rardin</B> began writing at the age of twelve. She penned eight Jaz Parks novels in her life. She passed away in September 2010.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4d41001f